import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import apiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "api/dog/testna_postaja/spremniDokument";

export const TEST_STATION_INVOICE_ATTACHMENT_TYPE = "NAROCILNICA";

export const createTestStationInvoice = createAsyncThunk(
  "invoice/testStation/create",
  async (values, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(baseUrl, values);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createTestStationInvoiceElement = createAsyncThunk(
  "invoice/testStation/createElement",
  async (values, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(`${baseUrl}/element`, values);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getTestStationInvoiceElement = createAsyncThunk(
  "invoice/testStation/pageElement",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `${baseUrl}/element/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const invoiceSlice = createSlice({
  name: "testStationInvoice",
  initialState: {
    error: null,
    isLoading: false,
    pricePerKg: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createTestStationInvoice.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createTestStationInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createTestStationInvoice.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createTestStationInvoiceElement.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createTestStationInvoiceElement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createTestStationInvoiceElement.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTestStationInvoiceElement.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTestStationInvoiceElement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getTestStationInvoiceElement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default invoiceSlice.reducer;
